"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResetLoginPwdWithOldPwdRequest = void 0;
var ResetLoginPwdWithOldPwdRequest = /** @class */ (function () {
    function ResetLoginPwdWithOldPwdRequest() {
    }
    return ResetLoginPwdWithOldPwdRequest;
}());
exports.ResetLoginPwdWithOldPwdRequest = ResetLoginPwdWithOldPwdRequest;
;
//# sourceMappingURL=resetLoginPwdWithOldPwd.request.js.map